import { render, staticRenderFns } from "./CityTabs.vue?vue&type=template&id=12f3e013&scoped=true"
import script from "./CityTabs.vue?vue&type=script&lang=js"
export * from "./CityTabs.vue?vue&type=script&lang=js"
import style0 from "./CityTabs.vue?vue&type=style&index=0&id=12f3e013&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12f3e013",
  null
  
)

export default component.exports